import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { handleErrorLocallyHttpOptions } from '../../interceptors/handle-error-locally.context';
import {
  UpdateLanguagePreferenceRequestBody,
  UserPreferencesDTO,
  UserProfileDTO
} from '../dtos/users/user-profile.dto';

/** Transport for the own-profile/preferences V3 endpoints. Errors are always handled locally by the caller. */
@Injectable({ providedIn: 'root' })
export class UserProfileHttpService {
  private readonly http = inject(HttpClient);

  public getMyProfile(): Observable<UserProfileDTO> {
    return this.http.get<UserProfileDTO>(
      `${environment.APIV3EndPoint}users/me/profile`,
      handleErrorLocallyHttpOptions(true)
    );
  }

  public getPreferences(): Observable<UserPreferencesDTO> {
    return this.http.get<UserPreferencesDTO>(
      `${environment.APIV3EndPoint}users/me/preferences`,
      handleErrorLocallyHttpOptions(true)
    );
  }

  public updatePreferences(body: UpdateLanguagePreferenceRequestBody): Observable<UserPreferencesDTO> {
    return this.http.put<UserPreferencesDTO>(
      `${environment.APIV3EndPoint}users/me/preferences`,
      body,
      handleErrorLocallyHttpOptions(true)
    );
  }
}
